import React from "react";

export interface ContentWrapperProps {
  children: React.ReactNode;
}

export interface ContentWrapperState {}

export const ContentWrapper = (props: ContentWrapperProps) => {
  return (
    <div className="content">
      <div className="container-fluid">{props.children}</div>
    </div>
  );
};

export default ContentWrapper;
